import styled from 'styled-components';

import { COLUMN_WIDTH } from '@src/styles/dimensions';
import { HStack, setAlpha } from '@talos/kyoko';

export const MarketDataCardsWrapper = styled(HStack)`
  flex: 1 1 0;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.backgroundBody};
`;

export const AddButton = styled.button.attrs(() => ({ type: 'button' }))`
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;
  color: ${({ theme }) => theme.colors.gray['080']};
  padding: 50px;
  height: auto;
  border: 1px dashed ${({ theme }) => theme.colors.gray['070']};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  transition: 250ms;

  svg {
    margin-bottom: ${({ theme }) => theme.spacing24}px;
    transition: 250ms;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.gray['090']};
    padding: 53px;

    svg {
      transform: scale(1.1);
    }
  }
`;

export const Filler = styled.div`
  width: ${COLUMN_WIDTH}px;
`;

export const Column = styled.div`
  position: relative;
  max-width: ${({ theme }) => COLUMN_WIDTH + theme.spacing2}px;

  div {
    outline: none;
  }
`;

export const DragWrapper = styled.div`
  margin: ${({ theme }) => `0 ${theme.spacing2}px ${theme.spacing2}px 0`};
`;

export const Cards = styled.div<{ isEmptyView: boolean }>`
  background: ${({ theme }) => setAlpha(0.6, theme.colors.gray['010'])};
  display: grid;
  flex: 1 1 0;
  ${({ isEmptyView, theme }) =>
    !isEmptyView &&
    `
		grid-template-columns: repeat(auto-fill, ${COLUMN_WIDTH + theme.spacing2}px);
		grid-auto-flow: column;
	`};
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  // This was added to get around an issue where the bottom scrollbar of this div was taking precedence over popovers etc on hover
  z-index: 1;
`;

export const IconWrapper = styled.div<{ isActive: boolean }>`
  padding-left: ${({ theme }) => theme.spacing4}px;
  justify-content: center;
  align-items: center;
  width: ${({ isActive }) => (isActive ? '20px' : '0')};
  transition: width 200ms ease;
`;
